// Saga for manage license
// import saga helper
import { call, put, all, takeLatest } from "redux-saga/effects";

// import actionType
import {
  GET_LICENSES_SUBSCRIPTION_LIST,
  GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST,
  REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW,
  CONFIRM_SUBSCRIPTION_LICENSES_ORDER,
  UPDATE_SUBSCRIPTION_LICENSES_ORDER,
  UNASSIGN_LICENSE_FROM_USER,
  GET_SUBSCRIPTION_PRODUCT_LIST,
  GET_USER_LICENCE_LIST,
} from "./actionType";

// import action
import {
  getLicensesSubscriptionListSuccess,
  getLicensesSubscriptionListFailure,
  getLicensesSubscriptionProductListSuccess,
  getLicensesSubscriptionProductListFailure,
  requestSubscriptionLicensesOrderPreviewSuccess,
  requestSubscriptionLicensesOrderPreviewFailure,
  confirmSubscriptionLicensesOrderSuccess,
  confirmSubscriptionLicensesOrderFailure,
  updateSubscriptionLicensesOrderSuccess,
  updateSubscriptionLicensesOrderFailure,
  unassignLicenseFromUserSuccess,
  unassignLicenseFromUserFailure,
  getSubscriptionProductListSuccess,
  getSubscriptionProductListFailure,
  getUserLicenceListSuccess,
  getUserLicenceListFailure,
} from "./action";
import {
  getLicensesSubscriptionListApi,
  getLicensesSubscriptionProductListApi,
  requestSubscriptionLicensesOrderPreviewApi,
  confirmSubscriptionLicensesOrderApi,
  updateSubscriptionLicensesOrderApi,
  unassignLicenseFromUserApi,
  getSubscriptionProductListApi,
  getUserLicenceListApi,
} from "../../helpers/fakebackend_helper";

// import fakeBackend_helper

// get Licenses subscription list
function* getLicensesSubscriptionList() {
  try {
    const response = yield call(getLicensesSubscriptionListApi);
    yield put(getLicensesSubscriptionListSuccess(response));
  } catch (error) {
    yield put(getLicensesSubscriptionListFailure(error));
  }
}

// get Licenses subscription list
export function* watchGetLicensesSubscriptionList() {
  yield takeLatest(GET_LICENSES_SUBSCRIPTION_LIST, getLicensesSubscriptionList);
}

// get Licenses subscription product list
function* getLicensesSubscriptionProductList() {
  try {
    const response = yield call(getLicensesSubscriptionProductListApi);
    yield put(getLicensesSubscriptionProductListSuccess(response));
  } catch (error) {
    yield put(getLicensesSubscriptionProductListFailure(error));
  }
}

// get Licenses subscription product list
export function* watchGetLicensesSubscriptionProductList() {
  yield takeLatest(
    GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST,
    getLicensesSubscriptionProductList
  );
}

// Request Subscription Licenses Order Preview
function* requestSubscriptionLicensesOrderPreview({ payload }) {
  try {
    const response = yield call(
      requestSubscriptionLicensesOrderPreviewApi,
      payload
    );
    yield put(requestSubscriptionLicensesOrderPreviewSuccess(response));
  } catch (error) {
    yield put(requestSubscriptionLicensesOrderPreviewFailure(error));
  }
}

// Request Subscription Licenses Order Preview
export function* watchRequestSubscriptionLicensesOrderPreview() {
  yield takeLatest(
    REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW,
    requestSubscriptionLicensesOrderPreview
  );
}

// Confirm Subscription Licenses Order
function* confirmSubscriptionLicensesOrder({ payload }) {
  try {
    const response = yield call(confirmSubscriptionLicensesOrderApi, payload);
    yield put(confirmSubscriptionLicensesOrderSuccess(response));
  } catch (error) {
    yield put(confirmSubscriptionLicensesOrderFailure(error));
  }
}

// Confirm Subscription Licenses Order
export function* watchConfirmSubscriptionLicensesOrder() {
  yield takeLatest(
    CONFIRM_SUBSCRIPTION_LICENSES_ORDER,
    confirmSubscriptionLicensesOrder
  );
}

// Update Subscription Licenses Order
function* updateSubscriptionLicensesOrder({ payload }) {
  try {
    const response = yield call(updateSubscriptionLicensesOrderApi, payload);
    yield put(updateSubscriptionLicensesOrderSuccess(response));
  } catch (error) {
    yield put(updateSubscriptionLicensesOrderFailure(error));
  }
}

// Update Subscription Licenses Order
export function* watchUpdateSubscriptionLicensesOrder() {
  yield takeLatest(
    UPDATE_SUBSCRIPTION_LICENSES_ORDER,
    updateSubscriptionLicensesOrder
  );
}

// Unassign License from user
function* unassignLicenseFromUser({ payload }) {
  try {
    const response = yield call(unassignLicenseFromUserApi, payload);
    yield put(unassignLicenseFromUserSuccess(response));
  } catch (error) {
    yield put(unassignLicenseFromUserFailure(error));
  }
}

// Unassign License from user
export function* watchUnassignLicenseFromUser() {
  yield takeLatest(UNASSIGN_LICENSE_FROM_USER, unassignLicenseFromUser);
}

// Get Subscription Product List
function* getSubscriptionProductList() {
  try {
    const response = yield call(getSubscriptionProductListApi);
    yield put(getSubscriptionProductListSuccess(response));
  } catch (error) {
    yield put(getSubscriptionProductListFailure(error));
  }
}

// Get Subscription Product List
export function* watchGetSubscriptionProductList() {
  yield takeLatest(GET_SUBSCRIPTION_PRODUCT_LIST, getSubscriptionProductList);
}

// Get all licences held by a single user
function* getUserLicenceList({ payload }) {
  try {
    const response = yield call(getUserLicenceListApi, payload);
    yield put(getUserLicenceListSuccess(response));
  } catch (error) {
    yield put(getUserLicenceListFailure(error));
  }
}

// Get all licences held by a single user
export function* watchGetUserLicenceList() {
  yield takeLatest(GET_USER_LICENCE_LIST, getUserLicenceList);
}

// export function for rootSaga
export default function* ManageLicense() {
  yield all([
    watchGetLicensesSubscriptionList(),
    watchGetLicensesSubscriptionProductList(),
    watchRequestSubscriptionLicensesOrderPreview(),
    watchConfirmSubscriptionLicensesOrder(),
    watchUpdateSubscriptionLicensesOrder(),
    watchUnassignLicenseFromUser(),
    watchGetSubscriptionProductList(),
    watchGetUserLicenceList(),
  ]);
}
